import { emptys } from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";
import { isDateBetween } from "../../../utils/isDateBetween";
import { toPrice } from "../../../utils/toPrice";

export const getPriceOrOffer = ({ data, price, country, rate }: stdObject) => {
  const today = new Date();
  const year = today.getFullYear();
  const currentDate = `${year}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  const week = today.getDay();

  if (country in data.OFEART) {
    let offer: stdObject = {};
    [2, 1, 3, 0].forEach((e) => {
      if (!offer.data) {
        data.OFEART[country]
          .filter(
            (v: stdObject) =>
              v.DATOFE === e && (v.TAROFE === rate || v.TAROFE === 0),
          )
          .sort((a: any, b: any) => b.TAROFE - a.TAROFE)
          .forEach((o: stdObject) => {
            if (!offer.data) {
              try {
                const activeDays = e > 0 ? JSON.parse(o.DAYSOFE) : "";
                switch (e) {
                  case 0:
                    offer.data = o;
                    break;
                  case 1:
                    if (
                      isDateBetween(
                        currentDate,
                        `${year}-${activeDays[0]}`,
                        emptys.includes(activeDays[1])
                          ? ""
                          : `${year}-${activeDays[1]}`,
                      )
                    ) {
                      offer.data = o;
                    }
                    break;
                  case 2:
                    activeDays.forEach((m: Array<string>) => {
                      if (
                        !offer.data &&
                        isDateBetween(
                          currentDate,
                          `${year}-${m[0]}`,
                          emptys.includes(m[1]) ? "" : `${year}-${m[1]}`,
                        )
                      ) {
                        offer.data = o;
                      }
                    });
                    break;
                  case 3:
                    if (activeDays[week]) {
                      offer.data = o;
                    }
                    break;
                }
              } catch (error) {
                console.log("offer error:", error);
              }
            }
          });
      }
    });
    if (offer.data) {
      price = Number(
        toPrice(
          offer.data.TIPOFE
            ? price - (offer.data.PREOFE / 100) * price
            : offer.data.PREOFE,
        ),
      );
    }
  }
  return price;
};
